import { makeStyles } from "@material-ui/core";

export const DocumentationRequestStyle = makeStyles((theme) => ({
    button: {
        marginRight: '1rem'
    }
}));